import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetMoneyPageIsEnabled as SetMoneyPageIsEnabledMutation,
    SetMoneyPageIsEnabledVariables,
    UrlSetIsEnabledInput,
} from 'nutshell-graphql-types';

import SET_MONEY_PAGE_IS_ENABLED from '../mutations/set-money-page-is-enabled.graphql';

export const useSetMoneyPageIsEnabled = (): {
    setMoneyPageIsEnabled: (arg1: UrlSetIsEnabledInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setMoneyPageIsEnabled, {loading, error}] = useMutation<
        SetMoneyPageIsEnabledMutation,
        SetMoneyPageIsEnabledVariables
    >(SET_MONEY_PAGE_IS_ENABLED);

    return {
        setMoneyPageIsEnabled: (input: UrlSetIsEnabledInput) =>
            setMoneyPageIsEnabled({
                variables: {input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'Mutation',
                    maUrlSetIsEnabled: {
                        __typename: 'UrlSetIsEnabledPayload',
                        url: {
                            __typename: 'MaUrl',
                            id: input.id,
                            isEnabled: input.isEnabled,
                        },
                    },
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
